import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from '../../core/service/backend/his-backend.service';

import { HisRouteDataKeys } from '../../core/model/his-route-data-keys';
import { HisRouteService } from '../../core/service/routing/his-route.service';
import { HisSearchCriteriaSet } from '../model/his-search-criteria-set';
import { HisSearchCriteriaSetRequest } from '../model/his-search-criteria-set-request';
import { HisSearch } from '../model/search/his-search';

@Injectable({providedIn: 'root'})
export class HisSearchCriteriaSetService {
    private backendService = inject( HisBackendService );
    private routeService = inject( HisRouteService );

    private searchCriteriaSet$: Observable<HisSearchCriteriaSet>;

    getSearchCriteriaSets( searchCriteriaSetRequest: HisSearchCriteriaSetRequest ): Observable<HisSearchCriteriaSet[]> {
        return this.backendService.postData( 'api/v1/cs/sys/genericSearch/getSearchCriteriaSets', searchCriteriaSetRequest );
    }

    // das ist die neue Methode die ein his-search zurück gibt
    loadCriteriaSet( searchCriteriaSetId: number ): Observable<HisSearch> {
        return this.backendService.getData( 'api/v1/cs/sys/genericSearch/loadCriteriaSet/' + searchCriteriaSetId );
    }

    saveSearchCriteriaSet( searchCriteriaSet: HisSearchCriteriaSet ): Observable<HisSearchCriteriaSet> {
        if ( searchCriteriaSet.id ) {
            this.searchCriteriaSet$ = this.backendService.putData(
                `api/v1/cs/sys/genericSearch/updateSearchCriteriaSet/${searchCriteriaSet.id}`, searchCriteriaSet );
        } else {
            this.searchCriteriaSet$ = this.backendService.postData(
                'api/v1/cs/sys/genericSearch/saveSearchCriteriaSet', searchCriteriaSet );
        }
        return this.searchCriteriaSet$;
    }

    updateSearchCriteriaSet( searchCriteriaSet: HisSearchCriteriaSet ): Observable<HisSearchCriteriaSet> {
        return this.backendService.putData(
            `api/v1/cs/sys/genericSearch/updateSearchCriteriaSet/${searchCriteriaSet.id}`, searchCriteriaSet );
    }

    /**
     * Delete a search criteria set.
     *
     * @return Observable( 1 if delete was successful )
     */
    deleteSearchCriteriaSet( searchCriteriaSetId: number ): Observable<number> {
        return this.backendService.delete( `api/v1/cs/sys/genericSearch/deleteSearchCriteriaSet/${searchCriteriaSetId}` );
    }

    /**
     * Resolves to a key that can be used as `flowName` to persist search criteria sets for the current search form with.
     * 
     * A custom key can be provided via the route data under the `HisRouteDataKeys.SEARCH_CRITERIA_SET_FLOW_NAME` key:
     * ```ts
     * // xxx.routes.ts
     * route = {
     *   path: 'my-search',
     *   component: HisSearchFormComponent,
     *   data: {
     *     [HisRouteDataKeys.SEARCH_CRITERIA_SET_FLOW_NAME]: 'my-custom-flow-name',
     *     // or literally:
     *     searchCriteriaSetFlowName: 'my-custom-flow-name'
     *   }
     * } 
     * ```
     * @returns a key defined in the route data under the `SEARCH_CRITERIA_SET_FLOW_NAME` or the current route path as fallback
     */
    public getFlowNameForSearchCriteriaSets(): string {
        return this.routeService.getActivatedRouteData( HisRouteDataKeys.SEARCH_CRITERIA_SET_FLOW_NAME ) ?? this.routeService.getRoutePathTemplate();
    }
}
